import { fluid } from '@helpers/fluid';
import { ButtonReset } from '@helpers/global';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/image';
import { paragraphSmall } from '@helpers/typography';
import Image from '@stories/Components/Misc/Image/Image';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  &[data-layout='default'] {
    ${SectionWrapperStyles.Inner} {
      max-width: calc(1020px + (var(--sitePadding) * 2));
    }
  }
`;
const MediaWrapper = styled.figure ``;
const AspectRatio = styled.div `
  ${ButtonReset};
  ${imageWrapperPreserveRatio(1020, 573)}

  color: var(--fgColour);
  display: block;
  border-radius: 10px;

  &.focus-ring {
    outline: auto;
    outline-offset: 5px;
    outline-style: solid;
    outline-width: 2px;
  }
`;
const Img = styled(Image) `
  ${imageCoverContainer()}
`;
const PlayIcon = styled.span `
  color: #ff0000;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: ${fluid(12, 18)};

  > svg {
    display: block;
    width: 68px;
    height: 48px;
  }
`;
const Caption = styled.figcaption `
  ${paragraphSmall};

  color: var(--fgColour);
  margin: ${fluid(12, 32)} 0 0;
  letter-spacing: 0.1em;
  text-transform: uppercase;
`;
const MediaEmbedStyles = {
    AspectRatio,
    Caption,
    Container,
    Img,
    MediaWrapper,
    PlayIcon,
};
export default MediaEmbedStyles;
